var render, staticRenderFns
import script from "./nSwitch.component.vue?vue&type=script&lang=ts"
export * from "./nSwitch.component.vue?vue&type=script&lang=ts"
import style0 from "./nSwitch.component.vue?vue&type=style&index=0&id=ec15d4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec15d4c0",
  null
  
)

export default component.exports